import { Action } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';
import { SportGlobelState } from '../interface/interface';
import { seeMorePopularDefaultValue } from '../utility/utility';

const initialState: SportGlobelState = {
	categoriesFlags: {},
	sportBreadcrumb: [],
	sportSeeMoreCount: seeMorePopularDefaultValue,
	sportCategorySeeMoreCount: seeMorePopularDefaultValue,
};

export const SportReducer = (state: SportGlobelState = initialState, action: Action): SportGlobelState => {
	switch (action.type) {
		case actionTypes.FETCH_CATEGORIES_FLAGS:
			return {
				...state,
				categoriesFlags: action.payload.categoriesFlags,
			};
		case actionTypes.SET_SPORT_BREADCRUMB:
			return {
				...state,
				sportBreadcrumb: action.payload.sportBreadcrumb,
			};
		case actionTypes.SET_SEEMORE_COUNT_SPORT:
			return {
				...state,
				sportSeeMoreCount: action.payload.sportSeeMoreCount,
			};
		case actionTypes.SET_SEEMORE_COUNT_SPORT_CATEGORY:
			return {
				...state,
				sportCategorySeeMoreCount: action.payload.sportCategorySeeMoreCount,
			};
		default:
			return state;
	}
};
